document.addEventListener("DOMContentLoaded", () => {
  const regularLabel = document.querySelector('label[for="enova-delivery-method-REGULAR"] .enova-shipping-method-title');
  const regularDesc = document.querySelector('label[for="enova-delivery-method-REGULAR"] .enova-shipping-method-tag-description p');

  if (regularLabel) {
    regularLabel.textContent = "Envío a Provincia";
  }

  if (regularDesc) {
    regularDesc.textContent = "Provincias: 7 - 10 días hábiles";
  }

  // Initialize Shipping Info Sidebar
  initShippingSidebar();
  
  // Initialize Countdown Timers
  initCountdownTimers();
  
  // Initialize Installments Message
  initInstallmentsMessage();
});

/**
 * Installments Message Update
 */
function initInstallmentsMessage() {
  const installmentsMessage = document.querySelector('[data-installments-message]');
  
  if (!installmentsMessage) return;
  
  const installmentsCount = parseInt(installmentsMessage.getAttribute('data-installments-count')) || 3;
  const messageTemplate = installmentsMessage.getAttribute('data-installments-template');
  
  // Función para actualizar el mensaje
  function updateInstallmentsMessage(variantPrice) {
    if (!variantPrice || variantPrice <= 0) {
      installmentsMessage.style.display = 'none';
      return;
    }
    
    installmentsMessage.style.display = 'block';
    
    // Calcular el monto de la cuota
    const installmentAmount = Math.floor(variantPrice / installmentsCount);
    
    // Formatear el monto con el símbolo de moneda
    const formattedAmount = formatMoney(installmentAmount);
    
    // Reemplazar las variables en el template
    const finalMessage = messageTemplate
      .replace('{count}', installmentsCount)
      .replace('{amount}', formattedAmount);
    
    installmentsMessage.textContent = finalMessage;
  }
  
  // Escuchar cambios de variante
  document.addEventListener('variant:change', (e) => {
    if (e.detail && e.detail.variant && e.detail.variant.price) {
      updateInstallmentsMessage(e.detail.variant.price);
    }
  });
  
  // También escuchar el evento nativo de Shopify
  document.addEventListener('change', (e) => {
    if (e.target.closest('variant-radios, variant-selects')) {
      // Esperar un momento para que se actualice el precio
      setTimeout(() => {
        const priceElement = document.querySelector('[data-price]');
        if (priceElement) {
          const priceText = priceElement.textContent.replace(/[^0-9]/g, '');
          const price = parseInt(priceText);
          if (price) {
            updateInstallmentsMessage(price);
          }
        }
      }, 100);
    }
  });
}

// Función auxiliar para formatear moneda (compatible con el formato de Shopify)
function formatMoney(cents) {
  const money_format = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : 'S/ {{amount}}';
  
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision || 2;
    thousands = thousands || ',';
    decimal = decimal || '.';
    
    if (isNaN(number) || number == null) {
      return 0;
    }
    
    number = (number / 100.0).toFixed(precision);
    
    const parts = number.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const cents = parts[1] ? (decimal + parts[1]) : '';
    
    return dollars + cents;
  }
  
  switch (money_format.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  
  return money_format.replace(placeholderRegex, value);
}

/**
 * Shipping Info Sidebar Functionality - Versión simplificada
 */
function initShippingSidebar() {
  console.log('Inicializando shipping sidebar...');
  
  // Usar delegación de eventos en el documento
  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('[data-shipping-trigger]');
    
    if (trigger) {
      e.preventDefault();
      console.log('Click detectado en trigger');
      
      const sidebarId = trigger.getAttribute('data-sidebar-target');
      const method = trigger.getAttribute('data-shipping-trigger');
      const sidebar = document.getElementById(sidebarId);
      
      console.log('Sidebar ID:', sidebarId);
      console.log('Method:', method);
      console.log('Sidebar encontrado:', sidebar);
      
      if (sidebar) {
        openSidebar(sidebar, method);
      }
      return;
    }
    
    // Cerrar sidebar
    const closeBtn = e.target.closest('[data-sidebar-close]');
    if (closeBtn) {
      const sidebar = closeBtn.closest('[data-shipping-sidebar]');
      if (sidebar) {
        closeSidebar(sidebar);
      }
      return;
    }
    
    // Cambiar tab
    const tab = e.target.closest('[data-sidebar-tab]');
    if (tab) {
      const sidebar = tab.closest('[data-shipping-sidebar]');
      const method = tab.getAttribute('data-sidebar-tab');
      if (sidebar) {
        switchTab(sidebar, method);
      }
      return;
    }
  });
  
  // Cerrar con tecla ESC
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const activeSidebar = document.querySelector('[data-shipping-sidebar].is-active');
      if (activeSidebar) {
        closeSidebar(activeSidebar);
      }
    }
  });
}

function openSidebar(sidebar, method) {
  console.log('Abriendo sidebar con método:', method);
  sidebar.classList.add('is-active');
  document.body.style.overflow = 'hidden';
  switchTab(sidebar, method);
}

function closeSidebar(sidebar) {
  console.log('Cerrando sidebar');
  sidebar.classList.remove('is-active');
  document.body.style.overflow = '';
}

function switchTab(sidebar, method) {
  console.log('Cambiando a tab:', method);
  
  // Update tabs
  const tabs = sidebar.querySelectorAll('[data-sidebar-tab]');
  tabs.forEach(tab => {
    if (tab.getAttribute('data-sidebar-tab') === method) {
      tab.setAttribute('aria-selected', 'true');
    } else {
      tab.setAttribute('aria-selected', 'false');
    }
  });

  // Update content
  const contents = sidebar.querySelectorAll('[data-sidebar-content]');
  contents.forEach(content => {
    if (content.getAttribute('data-sidebar-content') === method) {
      content.classList.add('is-active');
    } else {
      content.classList.remove('is-active');
    }
  });
}

// Exponer funciones globalmente para que puedan ser llamadas desde el snippet
window.initShippingSidebar = initShippingSidebar;


/**
 * Countdown Timer Functionality
 */
function initCountdownTimers() {
  console.log('Inicializando countdown timers...');
  
  const countdowns = document.querySelectorAll('[data-countdown-target], [data-countdown-target-sidebar]');
  console.log('Countdowns encontrados:', countdowns.length);
  
  countdowns.forEach(countdown => {
    // Evitar múltiples inicializaciones
    if (countdown.dataset.initialized === 'true') return;
    countdown.dataset.initialized = 'true';
    
    const dateStr = countdown.getAttribute('data-countdown-date');
    const timeStr = countdown.getAttribute('data-countdown-time');
    
    if (!dateStr || !timeStr) {
      console.log('Falta fecha o hora en countdown');
      return;
    }
    
    // Parse the target date/time
    const [year, month, day] = dateStr.split('-').map(Number);
    const [hours, minutes] = timeStr.split(':').map(Number);
    
    // Create target date in local timezone
    const targetDate = new Date(year, month - 1, day, hours, minutes, 0);
    
    console.log('Target date:', targetDate);
    
    // Update countdown immediately
    updateCountdown(countdown, targetDate);
    
    // Update every second
    const intervalId = setInterval(() => {
      updateCountdown(countdown, targetDate);
    }, 1000);
    
    // Guardar el intervalId para poder limpiarlo después si es necesario
    countdown.dataset.intervalId = intervalId;
  });
}

window.initCountdownTimers = initCountdownTimers;

function updateCountdown(element, targetDate) {
  const now = new Date();
  const diff = targetDate - now;
  
  if (diff <= 0) {
    element.textContent = '00:00:00';
    return;
  }
  
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);
  
  const hoursStr = String(hours).padStart(2, '0');
  const minutesStr = String(minutes).padStart(2, '0');
  const secondsStr = String(seconds).padStart(2, '0');
  
  element.textContent = `${hoursStr}:${minutesStr}:${secondsStr}`;
}

